import "./BudgetBuilder.scss";
import React from "react";
import { RouteComponentProps } from "@reach/router";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface BudgetBuilderProps {}

// eslint-disable-next-line no-empty-pattern
const BudgetBuilder = ({}: RouteComponentProps & BudgetBuilderProps): JSX.Element => {
  return <div className="budgetBuilderContainer">Budget Builder Placeholder</div>;
};

export default BudgetBuilder;
